
<button style="outline: none;" *ngIf="data.userType.access != 'restric'" class="close-button forgetPass"
  [mat-dialog-close]="true" id="closeBtn">
  <img src="../../../assets/icons/x-button.svg">
</button>
<div class="confir_sec">
  <div class="row">
    <div class="col-sm-12">
      <img height="60px" width="60px" style="float: left;" [defaultImage]="defaultImage" [lazyLoad]="data.userType.imgPath">
    </div>
    <div class="col-sm-12 successTitle">
      <h2>{{data.userType.titleOne}}</h2>
      <p></p>
      <p>{{data.userType.text}}</p>
    </div>
  </div>







  <mat-dialog-actions style=" gap: 13px; margin: 0; padding: 0;" *ngIf="data.userType.access == 'EventDelete'"
  class="action_sec">
  <button class="btn_yes" mat-raised-button style="" (click)="EvenctDeletOk(data.userType.id)" [mat-dialog-close]="true">Yes</button>
  <button class="btn_no" mat-raised-button style="" [mat-dialog-close]="true" (click)="EvenctDeletNo(data.userType.id)">No</button>
</mat-dialog-actions>


</div>
